import { Chip } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import { QUALITY_APPROVAL_STATUS_TO_LABEL } from "../constants"

import { QualityApprovalStatus } from "@/graphql/codegen/graphql"

const STATUS_TO_COLOR: Record<QualityApprovalStatus, string> = {
  [QualityApprovalStatus.Pending]: "bg-tertiary-orange-300",
  [QualityApprovalStatus.Approved]: "bg-tertiary-green-100",
  [QualityApprovalStatus.Denied]: "bg-secondary-200",
  [QualityApprovalStatus.Canceled]: "bg-secondary-200",
}

interface QualityApprovalStatusCellProps {
  status: QualityApprovalStatus
}

export const QualityApprovalStatusCell: FC<QualityApprovalStatusCellProps> = ({ status }) => (
  <Chip
    className={twMerge("h-6 rounded text-xs", STATUS_TO_COLOR[status])}
    label={QUALITY_APPROVAL_STATUS_TO_LABEL[status]}
    size='small'
  />
)
